/**
 * @brief   Définition des fonctionnalités AJAX
 * @author  cedric.durand@devicom.com
 */
class AppAjax {

    /**
     * @brief   Constructeur de la Classe via un Singleton.
     */
    constructor() {
        // Initialisation du Singleton
        if (AppAjax._instance instanceof AppAjax) {
            return AppAjax._instance;
        }

        // Initialisation du csrf-token()%
        this._token = jQuery('meta[name="csrf-token"]').attr('content');
        AppAjax._instance = this;

        // Contrôle de la validité de la session si le chemin n'est pas la page de Login
        if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
            this.isSessionValid();
        }
    }

    /**
     * @brief   Récupération de l'instance du Singleton.
     * @returns {AppAjax}
     */
    static getInstance() {
        // Initialisation du Singleton
        if (typeof(AppAjax._instance) == 'undefined') {
            AppAjax._instance = new AppAjax();
        }
        return AppAjax._instance;
    }

    /**
     * @brief   Vérification de l'expiration de la session.
     *
     * @remark  Si la session est échue, l'utilisateur est redirigé sur la page principale.
     *          L'interface d'authentification sera alors affichée.
     *
     * @return  void
     */
    isSessionValid() {
        // Validation de la session régulièrement
        if (typeof(AppAjax._instance.waitingTimeOut) != 'undefined') {
            clearTimeout(AppAjax._instance.waitingTimeOut);
        }

        // Vérification de la session toutes les 5min
        AppAjax._instance.waitingTimeOut = setTimeout(function() {
            // Vérification que la session est toujours valide
            jQuery.get('/ajax/session_check').done(function (response) {
                if (typeof (response.status) != 'undefined') {
                    // Fonctionnalité réalisée si l'expiration de la session est échue
                    if (response.results.lifetime <= 0) {
                        // Retour à la page de connexion
                        window.location.replace('/logout');
                        return false;
                    }
                }
            });
            AppAjax._instance.isSessionValid();
        }, 300000);
    }

    /**
     * @brief   Actualisation du csrf-tocken()
     * @param   callback    object : (option) fonction à appeler
     * @return  void
     */
    refreshCsrfToken(callback) {
        // Récupération du tocken courant
        jQuery.get('/ajax/refresh_csrf').done(function(response) {
            var item = typeof(response[0]) != 'undefined' ? response[0] : null;
            // Fonctionnalité réalisée si la réponse est valide
            if (typeof(item.value) != 'undefined') {
                // Fonctionnalité réalisée si la valeur est différente
                if (AppAjax._instance._token !== item.value) {
                    // Récupération du `csrf-tocken`
                    let new_token = item.value;
                    // Mise à jour de la métadonnée
                    jQuery('meta[name="csrf-token"]').attr('content', new_token);
                    // Mise à jour du champ caché
                    jQuery('input[name="_token"]').each(function() {
                        jQuery(this).val(new_token);
                    });
                    // Mise à jour du `csrf-tocken`
                    AppAjax._instance._token = new_token;
                    // Réinitialisation des paramètres AJAX
                    jQuery.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': AppAjax._instance._token
                        }
                    });
                }
            }
        });

        // Fonctionnalité réalisée si la fonction est valide
        if (typeof(callback) === 'function') {
            // Appel de la fonction avec un léger décallage
            setTimeout(function() {
                callback.call();
            }, 200);
        }
    }

    /**
     * @brief   Effacement du champ <SELECT>
     *
     * @param   selector    string : cible de l'élément à modifier
     * @param   optionText  string : (option)
     * @param   optionValue string : (option)
     * @param   loading     string : (option) classe de l'indicateur de chargement
     * @return  void
     */
    clearSelectOptions(selector, optionText, optionValue, loading) {
        // Récupération du texte du premier champ vide s'il existe
        let firstItem;
        if (jQuery(selector).find('option:first').val() === '') {
            firstItem = jQuery(selector).first().find('option:first').text();
        }
        // Initialise les valeurs par défaut
        if (typeof(firstItem) != 'undefined') {
            optionText  = firstItem;
            optionValue = '';
        }
        // Initialisation du champ avec une seule option
        jQuery(selector).html(new Option(optionText, optionValue)).addClass(loading);
    }

    /**
     * @brief   Exécution d'une requête AJAX.
     *
     * @remark  Désactiver AjaxController._return_simple_json
     *
     * @param   action      string : action du contrôleur AjaxController
     * @param   param       string : paramètre de la requête AJAX
     * @param   onSuccess   object : fonctionnalité exécutée une fois la requête terminée
     * @param   onError     object : fonctionnalité exécutée si une erreur est rencontrée
     * @return  void
     */
    executeAction(action, param, onSuccess, onError) {
        jQuery.ajax({
            async:      true,
            url:        '/ajax',
            method:     'POST',
            dataType:   'JSON',
            data: {
                action: action,
                lang:   jQuery('html').attr('lang'),
                param:  param
            },
            success:    function(response) {
                // Fonctionnalité réalisée si la fonction est valide
                if (typeof(onSuccess) === 'function') {
                    // Appel de la fonction en cas de succès
                    onSuccess(response);
                }
            },
            complete:   function(response) {
                // Fonctionnalité réalisée si la réponse Ajax n'est plus valide suite à une perte de @token
                if (response.status === 419) {
                    // Actualisation du `csrf-tocken` dans le HEADER et exécute de nouveau la requête AJAX
                    AppAjax._instance.refreshCsrfToken(function() { AppAjax._instance.executeAction(action, param, onSuccess, onError); } );
                }
            },
            error:      function(response) {
                // Fonctionnalité réalisée si la fonction est valide
                if (typeof(onError) === 'function') {
                    // Appel de la fonction en cas d'erreur
                    onError(response);
                }
            }
        });
    }

    /**
     * @brief   Convertion d'un nombre au format téléphonique.
     *
     * @param   phoneNumber integer : numéro de téléphone au format numérique
     * @param   postNumber  integer : (option) numéro du poste
     * @return  string|null
     */
    formatPhoneNumber(phoneNumber, postNumber) {
        // Élimination des caractères non désirés
        let cleanedPhone = ('' + phoneNumber).replace(/\D/g, '');
        let cleanedPost = '';
        if (typeof(postNumber) != 'undefined') {
            cleanedPost = ('' + postNumber).replace(/\D/g, '');
        }
        // Teste si les chiffres correspondent
        let match = cleanedPhone.match(/^(\d*)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            // Traitement du code du pays
            let intlCode = (match[1] ? '+{0} '.format(match[1]) : '');
            // Conversion sous forme de tableau
            let listItems = [intlCode, '(', match[2], ') ', match[3], '-', match[4]];
            // Ajout du poste s'il existe
            if (cleanedPost > 0) {
                listItems.push(' *' + cleanedPost);
            }
            // Renvoi du traitement
            return listItems.join('');
        }
        return null;
    }

    /**
     * @brief   Chargement du champ <SELECT> à partir d'une requête AJAX.
     *
     * @param   selector    string : cible de l'élément à modifier
     * @param   action      string : action du contrôleur AjaxController
     * @param   param       string : paramètre de la requête AJAX
     * @param   selected    string : (option) valeur sélectionnée par défaut
     * @param   loading     string : (option) classe de l'indicateur de chargement
     * @return  void
     */
    updateSelectOptions(selector, action, param, selected, loading) {
        // Récupération du texte du premier champ vide s'il existe
        let firstItem;
        if (jQuery(selector).find('option:first').val() === '') {
            firstItem = jQuery(selector).first().find('option:first').text();
        }

        // Indicateur de chargement
        jQuery(selector).html(new Option('', '')).addClass(loading);

        // Mise à jour AJAX
        jQuery.ajax({
            async:      true,
            url:        '/ajax',
            method:     'POST',
            dataType:   'JSON',
            data: {
                action: action,
                lang:   jQuery('html').attr('lang'),
                param:  param
            },
            success:    function(response) {
                // Suppression de l'indicateur de chargement
                jQuery(selector).removeClass(loading);
                // Initialisation de la liste avec un premier vide
                if (typeof(firstItem) != 'undefined') {
                    jQuery(selector).html(new Option(firstItem, '', true));
                }
                // Chargement de la liste
                if (typeof(response.results) != 'undefined') {
                    // Chargement de la liste à partir de response.results = array(value => text)
                    jQuery.each(response.results, function(value, text) {
                        // Ajout d'une option
                        jQuery(selector).append(new Option(text, value));
                    });
                } else {
                    // Chargement de la liste à partir de response = array(data => array(id, value))
                    jQuery.each(response, function(item, data) {
                        // Ajout d'une option
                        jQuery(selector).append(new Option(data.value, data.index));
                    });
                }
            },
            complete:   function(response) {
                // Fonctionnalité réalisée si la réponse Ajax n'est plus valide suite à une perte de @token
                if (response.status === 419) {
                    // Actualisation du `csrf-tocken` dans le HEADER et exécute de nouveau la requête AJAX
                    AppAjax._instance.refreshCsrfToken(function() { AppAjax._instance.updateSelectOptions(selector, action, param, selected, loading); });
                } else {
                    // Fonctionnalité réalisée si une valeur est à sélectionner par défaut
                    if (typeof (selected) != 'undefined') {
                        // Sélection de l'élément par sa valeur
                        jQuery(selector).find('option[value="' + selected + '"]').prop('selected', true);
                    }
                }
            },
            error:      function() {
                // Suppression de l'indicateur de chargement
                jQuery(selector).removeClass(loading);
                // Suppression du contenu avec un style
                jQuery(selector).html(new Option('Error !', 'undefined'));
            }
        });
    }

    /**
     * @brief   Chargement du champ <INPUT> à partir d'une requête AJAX.
     *
     * @param   selector    string : cible de l'élément à modifier
     * @param   action      string : action du contrôleur AjaxController
     * @param   param       string : paramètre de la requête AJAX
     * @param   loading     string : (option) classe de l'indicateur de chargement
     * @return  void
     */
    updateInput(selector, action, param, loading) {
        // Ajout de l'indicateur de chargement
        jQuery(selector).addClass(loading);

        // Mise à jour AJAX
        jQuery.ajax({
            async:      true,
            url:        '/ajax',
            method:     'POST',
            dataType:   'JSON',
            data: {
                action: action,
                lang:   jQuery('html').attr('lang'),
                param:  param
            },
            success:    function(response) {
                // Suppression de l'indicateur de chargement
                jQuery(selector).removeClass(loading);
                // Chargement de la valeur
                jQuery.each(response, function(item, data) {
                    // Mise à jour de la valeur
                    jQuery(selector).val(data.value);
                });
            },
            complete:   function(response) {
                // Fonctionnalité réalisée si la réponse Ajax n'est plus valide suite à une perte de @token
                if (response.status === 419) {
                    // Actualisation du `csrf-tocken` dans le HEADER et exécute de nouveau la requête AJAX
                    AppAjax._instance.refreshCsrfToken(function() { AppAjax._instance.updateInput(action, param, selector, loading); });
                }
            },
            error:      function() {
                // Suppression de l'indicateur de chargement
                jQuery(selector).removeClass(loading);
                // Suppression du contenu avec un style
                jQuery(selector).val('Error !');
            }
        });
    }
}
// Enregistrement du Singleton dans la variable globale
window.AppAjax = new AppAjax();
